"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseTypeMap = void 0;
const enums_1 = require("../enums");
exports.responseTypeMap = {
    [enums_1.WindowProviderRequestEnums.signTransactionsRequest]: enums_1.WindowProviderResponseEnums.signTransactionsResponse,
    [enums_1.WindowProviderRequestEnums.guardTransactionsRequest]: enums_1.WindowProviderResponseEnums.guardTransactionsResponse,
    [enums_1.WindowProviderRequestEnums.signMessageRequest]: enums_1.WindowProviderResponseEnums.signMessageResponse,
    [enums_1.WindowProviderRequestEnums.loginRequest]: enums_1.WindowProviderResponseEnums.loginResponse,
    [enums_1.WindowProviderRequestEnums.reloginRequest]: enums_1.WindowProviderResponseEnums.reloginResponse,
    [enums_1.WindowProviderRequestEnums.logoutRequest]: enums_1.WindowProviderResponseEnums.disconnectResponse,
    [enums_1.WindowProviderRequestEnums.cancelAction]: enums_1.WindowProviderResponseEnums.cancelResponse,
    [enums_1.WindowProviderRequestEnums.finalizeHandshakeRequest]: enums_1.WindowProviderResponseEnums.noneResponse,
    [enums_1.WindowProviderRequestEnums.finalizeResetStateRequest]: enums_1.WindowProviderResponseEnums.resetStateResponse
};
//# sourceMappingURL=windowProviderConstants.js.map